import { render, staticRenderFns } from "./TuiGuang.vue?vue&type=template&id=195a266d&scoped=true&"
import script from "./TuiGuang.vue?vue&type=script&lang=js&"
export * from "./TuiGuang.vue?vue&type=script&lang=js&"
import style0 from "./TuiGuang.vue?vue&type=style&index=0&id=195a266d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a266d",
  null
  
)

export default component.exports